export enum AssetBuildingFilterSelection {
    Assets = "assets",
    Buildings = "buildings",
    Both = "both",
    None = "none"
}